@if (loading) {
  <app-loading-spinner></app-loading-spinner>
}
@if (showSelection && !loading && hasTemplates) {
  <div>
    <h1>Select Report</h1>
    <span class="mat-card-subtitle">Please select the report you would like to create</span>
    <div class="d-flex flex-column justify-content-start align-items-center">
      @for (template of templates; track template) {
        <button mat-flat-button color="primary" class="w-100 mb-3" type="button" (click)="selectTemplate(template.id)">{{template.template.title}}</button>
      }
    </div>
  </div>
}
@if (!showSelection && !loading) {
  <div class="report">
    @for (row of report.template.rows; track row; let rowIndex = $index) {
      <div class="report-row-container mb-3">
        @if (row.isRow) {
          <div class="report-row row">
            @for (control of row.controls; track control; let colIndex = $index) {
              <div class="report-control col col-sm {{control.widthClass}}">
                <app-report-control-editor [patientId]="report.patientId" [control]="control" (deleteControl)="onDelete(rowIndex, colIndex)"></app-report-control-editor>
              </div>
            }
          </div>
        }
        @if (row.isRowTitle) {
          <div class="report-row report-row-title w-100">
            <app-report-title-renderer [row]="row" [template]="report.template" [entryOptions]="entryOptions" (procedureEntryChange)="selectProcedureEntry($event)">
            </app-report-title-renderer>
          </div>
        }
      </div>
    }
  </div>
}
